import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ServiceService } from '../services/service.service';
import { Service } from '../models/service.model';
import { Product } from '../models/product.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { SpecialService } from '../services/special.service';
import { ProductService } from '../services/product.service';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'service',
  templateUrl: '../views/products/service.html',
  providers: [ServiceService,SpecialService,ProductService]
})
export class ServiceComponent{
  public title: string;
  public services: Service[];
  public submitServiceModel: Service;
  public products: Product[];
  public searchProducts: Product[];
  public founds: Product[];
  public message: any;
  public mode: string;
  public searching: boolean;
  public wait:boolean;
  public servicePrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private serviceService: ServiceService,
    public sharedVariables: VariableService,
    private specialService: SpecialService,
    private productService: ProductService
  )
  {

      this.title = null;
      this.mode = "submit-add";
      this.submitServiceModel = new Service(0,'',0);
      this.searching = false;
      this.wait = true;

  }

  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.servicePrivilege == 1){
                                    this.getAllServices();
                                    this.wait=false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllServices()
  {
    this.serviceService.getServices().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.services = result.data;
          console.log(this.services);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getAllProducts()
  {
    this.productService.getProducts().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.searchProducts = null;
        }else{
          this.searchProducts = result.data;
          console.log(this.searchProducts);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getProducts(id:number)
  {
    this.specialService.getProducts_Service(id).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.products = null;
        }else{
          this.products = result.data;
          console.log(this.products);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.saveService();
    }else{
      this.updateService();
    }

    this.mode = "submit-add";
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllServices();
                      this.submitServiceModel = new Service(0,'',0);
                    },this.sharedVariables.timeToLoad);
    console.log("mode",this.mode);
  }

  saveService()
  {
    this.serviceService.addService(this.submitServiceModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  editService(pService: Service)
  {
    this.mode = "submit-update";
    this.submitServiceModel = Object.assign({}, pService);
    this.getProducts(this.submitServiceModel.ID);
    this.getAllProducts();
    console.log("Checkout objects");
    console.log("mode",this.mode);
  }

  showResults(event: any) : void
  {
    if (event.target.value.length >= 3) {
      this.searching = true;
      //this.founds = this.searchProducts.filter(product => product.name === event.target.value);
      this.founds = this.searchProducts.filter(product => product.name.match(event.target.value));
      console.log(this.founds);
    } else {
      this.searching = false;
    }
  }

  updateService()
  {
      let id = this.submitServiceModel.ID;
      console.log("objeto update ",this.submitServiceModel);
      this.serviceService.updateService(id,this.submitServiceModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
  }

  AddProductInService(product_id:number)
  {
    console.log(this.submitServiceModel.ID, product_id);
    this.specialService.AddProductInService(this.submitServiceModel.ID, product_id).subscribe(
        response => {
          if(response.code == 200){
            this.getProducts(this.submitServiceModel.ID);
            console.log("Agregado");
          }
        },error =>{
          console.log(<any>error);
        }
    );
    this.searching = false;
  }

  deleteService(id: number)
  {
    this.serviceService.deleteService(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllServices();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  deleteProductInService(product_id: number)
  {
    console.log(this.submitServiceModel.ID, product_id);
    this.specialService.deleteProductInService(this.submitServiceModel.ID, product_id).subscribe(
        response => {
          if(response.code == 200){
            this.getProducts(this.submitServiceModel.ID);
            console.log("Eliminado");
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  cleanObject()
  {
    this.submitServiceModel = new Service(0,'',0);
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.servicePrivilege = response.data[0].service;
            console.log("Privilegios del usuario",this.servicePrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/service.component.ts